import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { LI, UL } from '../../../AbstractElements';
import { CrmsettingIconData } from '../../../Data/Layout/RightHeader';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../ReduxToolkit/Store';
import { useSafeNavigate } from '../../../Hooks/useSafeNavigate';

export default function UserWrap() {
    const [open, setOpen] = useState(false);
    const navigate = useSafeNavigate();
    const dropdownRef = useRef<HTMLDivElement>(null);
    const userData = useSelector((state: RootState) => state.adminAuth);

    const toggle = () => {
        setOpen(!open);
    };

    // Avatar initials
    const firstLetter = userData?.FirstName ? userData?.FirstName.charAt(0).toUpperCase() : '';
    const secondLetter = userData?.LastName ? userData?.LastName.charAt(0).toUpperCase() : '';
    const avatarText = firstLetter + secondLetter;

    // Logout handler
    const handleLogout = () => {
        localStorage.removeItem('crmtoken');
        localStorage.removeItem('crmsessionTime');
        navigate('/CRMLogin');
    };

    // Close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false); // Close the dropdown if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <li className="profile-nav custom-dropdown">
            <div className="user-wrap" onClick={toggle}>
                <div className="user-img">
                    <div 
                        className="avatar"
                        style={{
                            backgroundColor: 'blue',
                            color: 'white',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            cursor: 'pointer'
                        }}
                    >
                        {avatarText || 'U'} {/* Default to 'U' if no names are available */}
                    </div>
                </div>
            </div>
            <div className={`custom-menu overflow-hidden ${open ? 'show' : ''}`} ref={dropdownRef}>
                <UL className="profile-body simple-list">
                    {CrmsettingIconData.map((item) => (
                        <LI className="d-flex" key={item.id}>
                            <SvgIcon className='svg-color' iconId={item.icon} />
                            <Link className="ms-2" to={`${process.env.PUBLIC_URL}/${item.link}`}>
                                {item.text}
                            </Link>
                        </LI>
                    ))}
                    <LI className="d-flex" onClick={handleLogout}>
                        <SvgIcon className='svg-color' iconId='Login' />
                        <Link className="ms-2" to={`${process.env.PUBLIC_URL}/login`}>
                            {'Log Out'}
                        </Link>
                    </LI>
                </UL>
            </div>
        </li>
    );
}
